import React, { useEffect, useState } from 'react';

const FileCard = ({ file, onUpdateDocumentNumber, onUpdateDocumentName, onUpdateDocumentNumberLabel }) => {
  const { documentNumber, documentName, documentNumberLabel, documentType, lastModified } = file || {};
  
  // States for editing document number
  const [isEditingNumber, setIsEditingNumber] = useState(false);
  const [editedDocumentNumber, setEditedDocumentNumber] = useState(documentNumber || '');
  
  // States for editing document name
  const [isEditingName, setIsEditingName] = useState(false);
  const [editedDocumentName, setEditedDocumentName] = useState(documentName || '');

  const [isEditingLabel, setIsEditingLabel] = useState(false);
  const [editedLabel, setEditedLabel] = useState(file.documentNumberLabel || 'Document Number');

  // Document Number Editing
  const handleNumberEditClick = () => {
    setIsEditingNumber(true);
  };

  const handleNumberSaveClick = async () => {
    if (onUpdateDocumentNumber) {
      await onUpdateDocumentNumber(documentName, editedDocumentNumber);
    }
    setIsEditingNumber(false);
  };

  const handleNumberCancelClick = () => {
    setIsEditingNumber(false);
    setEditedDocumentNumber(documentNumber || '');
  };
  
  // Document Name Editing
  const handleNameEditClick = () => {
    setIsEditingName(true);
  };

  const handleNameSaveClick = async () => {
    if (onUpdateDocumentName) {
      await onUpdateDocumentName(documentName, editedDocumentName);
    }
    setIsEditingName(false);
  };

  const handleNameCancelClick = () => {
    setIsEditingName(false);
    setEditedDocumentName(documentName || '');
  };

  // Document Number Label Editing
  const handleLabelEditClick = () => {
    setIsEditingLabel(true);
  };

  const handleLabelSaveClick = async () => {
    if (onUpdateDocumentNumberLabel) {
      await onUpdateDocumentNumberLabel(documentName, editedLabel);
    }
    setIsEditingLabel(false);
  };

  const handleLabelCancelClick = () => {
    setIsEditingLabel(false);
    setEditedLabel(documentNumberLabel || 'Document Number');
  };

  // Update local state when props change
  useEffect(() => {
    setEditedDocumentNumber(documentNumber || '');
    setEditedDocumentName(documentName || '');
    setEditedLabel(documentNumberLabel || 'Document Number');
  }, [documentNumber, documentName, documentNumberLabel]);

  return (
    <div className="file-card">
      {/* Document Name - Editable */}
      <div className="document-name-container">
        {isEditingName ? (
          <div className="document-name-edit">
            <input
              type="text"
              className="document-name-input"
              value={editedDocumentName}
              onChange={(e) => setEditedDocumentName(e.target.value)}
              autoFocus
            />
            <div className="edit-actions">
              <button 
                className="save-button"
                onClick={handleNameSaveClick}
              >
                Save
              </button>
              <button 
                className="cancel-button"
                onClick={handleNameCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div className="document-name-display">
            <h3>{editedDocumentName || 'N/A'}</h3>
            <button 
              className="edit-button"
              onClick={handleNameEditClick}
            >
              Edit Name
            </button>
          </div>
        )}
      </div>
      
      {/* Document Number - Editable */}
      <div className="document-number-container">
        <div className="document-label-section">
          {isEditingLabel ? (
            <div className="edit-container">
              <input
                type="text"
                value={editedLabel}
                onChange={(e) => setEditedLabel(e.target.value)}
                className="edit-input"
              />
              <div className="button-group">
                <button onClick={handleLabelSaveClick} className="save-btn">Save</button>
                <button onClick={() => setIsEditingLabel(false)} className="cancel-btn">Cancel</button>
              </div>
            </div>
          ) : (
            <div className="label-display">
              <span className="label-text"><strong>{editedLabel || 'Document Number'}:</strong></span>
              <button onClick={() => setIsEditingLabel(true)} className="edit-btn">Edit Label</button>
            </div>
          )}
        </div>
        
        {isEditingNumber ? (
          <div className="document-number-edit">
            <input
              type="text"
              className="document-number-input"
              value={editedDocumentNumber}
              onChange={(e) => setEditedDocumentNumber(e.target.value)}
              autoFocus
            />
            <div className="edit-actions">
              <button 
                className="save-button"
                onClick={handleNumberSaveClick}
              >
                Save
              </button>
              <button 
                className="cancel-button"
                onClick={handleNumberCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div className="document-number-display">
            <span className="document-value">{editedDocumentNumber || 'N/A'}</span>
            <button 
              className="edit-button"
              onClick={handleNumberEditClick}
            >
              Edit
            </button>
          </div>
        )}
      </div>
      
      <p>Document Type: {documentType || 'N/A'}</p>
      <p>Last Modified: {lastModified ? new Date(lastModified).toLocaleString() : 'N/A'}</p>
    </div>
  );
};

export default FileCard;